module.exports = __webpack_public_path__ + "static/media/nora-narrow.4fe76145.png";